/**
 * 创建 React 挂载 dom 节点
 * @param selector
 * @param anchor
 */
export function mountNode(selector, anchor) {
    if (anchor === void 0) { anchor = undefined; }
    var node;
    if (!selector) {
        node = document.createElement('div');
        document.body.appendChild(node);
        return node;
    }
    if (typeof selector == 'string') {
        node = document.querySelector(selector);
    }
    else {
        node = selector;
    }
    var d = document.createElement('div');
    switch (anchor) {
        case 'append':
            node.appendChild(d);
            return d;
        case 'before':
            node.parentNode.insertBefore(d, node);
            return d;
        case 'after':
            if (node.nextSibling) {
                node.parentNode.insertBefore(d, node.nextSibling);
            }
            else {
                node.parentNode.appendChild(d);
            }
            return d;
    }
    return node;
}
;
//# sourceMappingURL=mount-node.js.map